// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"tg_a bii_rc bii_qx bii_xr","ContestPosts__more":"tg_b bii_vu bii_b bii_va bii_sv"};